module.exports = __webpack_public_path__ + "static/media/15.5a00b100.jpg";